export default "__VITE_ASSET__5689bc61__"